import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { RESIZE_URL } from 'utils/restapi';
import { patchLink } from 'redux/links/actions';

import { Button } from 'semantic-ui-react';
import CommonImageDropzone from 'components/common/CommonImageDropzone';

import LinkIcons from 'components/dashboard/links-content/LinkIcons';
import TooltipCommon from 'components/common/TooltipCommon';
import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';
import Parser from 'html-react-parser';

import './LinkThumbnail.css';


const LinkThumbnail = props => {
  const { t } = useTranslation();
  const { linkId, patchLink, itemThumbnail, itemThumbnailIcon, patchLinkSuccess, me } = props;
  const [showLoader, setShowLoader] = useState(false);
  const [isImageDragging, setImageDragging] = useState(false);
  const [showUploadModal, setUploadModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    if (patchLinkSuccess) {
      setTimeout(() => {
        setShowLoader(false);
      }, 1000);
    }
  }, [patchLinkSuccess]);

  const onImageDrop = droppedImage => {
    setPopupOpen(false);
    setUploadModal(false);

    if (droppedImage) {
      setShowLoader(true);
      const form = new FormData();
      form.append('thumbnail_icon', '');
      form.append('thumbnail', droppedImage.imageBlob, droppedImage.name);
      patchLink(linkId, form);
    }
  };

  const onImageRemove = () => {
    const form = new FormData();
    form.append('thumbnail', '');
    patchLink(linkId, form);
  };

  const onIconRemove = () => {
    const form = new FormData();
    form.append('thumbnail_icon', '');
    patchLink(linkId, form);
  };

  const renderTooltipContent = () => {
    return (
      <div className="tooltip-content">
        <div className="buttons-block">

          <CommonImageDropzone
            onDropImage={onImageDrop}
            className="upload-dropzone"
            onLoadSuccess={() => { setPopupOpen(false); }}
            onFailure={() => { setPopupOpen(false); }}
          >
            <Button
              className="button-item"
              content={itemThumbnail ? t("Change your image") : t("Upload your own image")}
            />
          </CommonImageDropzone>

          <ProFeaturePlaceholder
            key="background-image-selector-pro-feature-key"
            proLabel
            locked={me && me.subscription && !me.subscription.ff_link_thumbnail_icon}
            className="button-item"
          >
            <Button
              onClick={() => { setUploadModal(true); setPopupOpen(false); }}
              content={`${itemThumbnailIcon ? t("Edit your icon") : t("Choose from 700+ icons")}`}
              className="button-item"
            />

          </ProFeaturePlaceholder>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`link-thumbnail__component ${itemThumbnailIcon ? 'thumbnail-icon' : ''}`}
      style={{ backgroundImage: itemThumbnail && `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${itemThumbnail})` }}
    >
      {itemThumbnail &&
        <div className="delete-icon"
          onClick={onImageRemove}
          role="button"
          tabIndex={-1}
        />
      }

      {itemThumbnailIcon && Boolean(itemThumbnailIcon) &&
        <div className="delete-icon"
          onClick={onIconRemove}
          role="button"
          tabIndex={-1}
        />
      }

      <TooltipCommon
        key={`link-thumbnail-icon-tooltip-key-${linkId}`}
        overlayClassName="link-thumbnail-icon-tooltip__component"
        placement="bottom"
        trigger="click"
        visible={popupOpen}
        closeIcon
        onClose={() => { setPopupOpen(false); }}
        overlay={renderTooltipContent()}
      >
        <div
          className={`upload-selector ${isImageDragging ? 'dragging' : ''}`}
          onClick={() => { setPopupOpen(true); }}
          onDragEnter={() => { setImageDragging(true); }}
          onDragLeave={() => { setImageDragging(false); }}
        >
          {itemThumbnailIcon &&
            Parser(itemThumbnailIcon)
          }
        </div>
      </TooltipCommon>

      <CommonImageDropzone
        onDropImage={onImageDrop}
        loading={showLoader}
        className="upload-dropzone"
        onLoadSuccess={() => { setPopupOpen(false); }}
        onFailure={() => { setPopupOpen(false); }}
        noClick={itemThumbnail}
      ></CommonImageDropzone>

      {showUploadModal &&
        <LinkIcons
          open={showUploadModal}
          onClose={() => { setUploadModal(false); }}
          linkId={linkId}
          itemThumbnailIcon={itemThumbnailIcon}
        />
      }
    </div>
  );
};

LinkThumbnail.propTypes = {
  patchLink: PropTypes.func.isRequired,
  linkId: PropTypes.number.isRequired,
  itemThumbnail: PropTypes.string,
  patchLinkSuccess: PropTypes.object,
  itemThumbnailIcon: PropTypes.object,
  me: PropTypes.object,
};

LinkThumbnail.defaultProps = {
  itemThumbnail: null,
  patchLinkSuccess: null,
  itemThumbnailIcon: null,
  me: null,
};

const mapStateToProps = state => (
  {
    patchLinkSuccess: state.linksReducer.patchLinkSuccess,
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(LinkThumbnail);
